/**
 * Conversions tracking module.
 * Fires GA4 events (window.gtag) + dataLayer push (para Google Tag Manager si se instala).
 * En modo dev, imprime en consola para verificar.
 *
 * Eventos priorizados (CRO + Google Ads conversions):
 * - contact_whatsapp        · Click en WhatsApp
 * - contact_phone           · Click en teléfono
 * - contact_form_submit     · Envío formulario contacto
 * - pqrs_submit             · Envío formulario PQRS
 * - booking_start           · Selección tipo de cita
 * - booking_complete        · Reserva confirmada
 * - maps_directions         · Click en "Cómo llegar"
 * - reviews_open            · Click en "Ver reseñas Google"
 */
const isProd = typeof window !== "undefined" && window.location.hostname !== "localhost";

export function trackConversion(event, params = {}) {
  if (typeof window === "undefined") return;
  const payload = {
    event,
    ...params,
    page_location: window.location.href,
    page_path: window.location.pathname,
    _ts: Date.now(),
  };
  // dataLayer (GTM-compatible)
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  // gtag (GA4)
  if (typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
  if (!isProd) console.info("[conv]", event, params);
}

/** WhatsApp click helper — devuelve la URL y dispara el evento */
export function fireWhatsApp(url, source = "unknown") {
  trackConversion("contact_whatsapp", { source });
  return url;
}
export function firePhone(source = "unknown") {
  trackConversion("contact_phone", { source });
}
export function fireDirections(source = "unknown") {
  trackConversion("maps_directions", { source });
}
export function fireReviews(source = "unknown") {
  trackConversion("reviews_open", { source });
}
